/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, TextField, Button } from "@mui/material";

export const MobileUserActivityContainer = styled('div')({
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
})

export const StyledSearchBar = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #2b4fb9 !important'
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: '25px',
  },
  '& .MuiInputBase-root':{
    borderRadius: '25px',
    height: '2.4rem',
    paddingTop: '3px',
    fontSize: '15px',
    width: '253px !important',
    backgroundColor: "white",
    marginRight: '18px',
  },
})

export const StyledNameLink = styled(Button) ({
  '&.Mui-disabled': {
    color: '#348be5',
  },
  '&:hover': {
    textDecoration: 'underline !important',
    backgroundColor: 'transparent'
  },
  textDecoration: 'none',
  color: '#348be5',
  fontSize: '14px',
  textTransform: 'none',
  backgroundColor: 'transparent',
  fontWeight: '400',
})

export const StyledDate = styled('span')({
  '&:hover':{
    color: '#348be5',
    cursor: 'pointer',
  }
})
